import { Broadcast } from '../../types'

interface BroadcastInfoProps {
  broadcast: Broadcast | null
  autoDjText?: string
  autoDjSubtitle?: string
  autoDjCurrentTrack?: string | null    // NEW
  autoDjPlaylistName?: string | null    // NEW
}

export function BroadcastInfo({ broadcast, autoDjText, autoDjSubtitle, autoDjCurrentTrack }: BroadcastInfoProps) {
  // When there's a live broadcast, show broadcast info
  if (broadcast?.is_live) {
    return (
      <div className="space-y-6">
        {/* Live Indicator */}
        <div className="flex items-center justify-center gap-3 bg-[var(--success)]/10 border border-[var(--success)] rounded-lg py-3 px-4">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--success)] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-[var(--success)]"></span>
          </span>
          <span className="text-[var(--success)] font-bold text-lg">ON AIR</span>
        </div>

        {/* Show Info */}
        <div className="text-center space-y-2">
          {broadcast.show_name && (
            <h2 className="text-3xl font-bold text-[var(--text-primary)]">
              {broadcast.show_name}
            </h2>
          )}
          <p className="text-[var(--accent)] text-lg font-medium">
            עם {broadcast.broadcaster_name}
          </p>
          {broadcast.show_description && (
            <p className="text-[var(--text-secondary)] text-sm max-w-2xl mx-auto pt-2">
              {broadcast.show_description}
            </p>
          )}
        </div>

        {/* Current Track */}
        {(broadcast.current_track_name || broadcast.current_track_artist) && (
          <div className="bg-[var(--bg-tertiary)] rounded-lg p-4 border border-[var(--border-color)]">
            <div className="flex items-center gap-3">
              <div className="text-sm text-[var(--text-secondary)] font-semibold">NOW<br/>PLAYING</div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-[var(--text-secondary)] mb-1">מתנגן עכשיו</p>
                {broadcast.current_track_name && (
                  <p className="text-[var(--text-primary)] font-semibold truncate">
                    {broadcast.current_track_name}
                  </p>
                )}
                {broadcast.current_track_artist && (
                  <p className="text-[var(--text-secondary)] text-sm truncate">
                    {broadcast.current_track_artist}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  // When there's NO live broadcast, show AUTO DJ info
  return (
    <div className="space-y-6">
      {/* AUTO DJ Indicator */}
      <div className="flex items-center justify-center gap-3 bg-[var(--accent)]/10 border border-[var(--accent)] rounded-lg py-3 px-4">
        <span className="text-[var(--accent)] font-bold text-lg">נטקות מן העבר</span>
      </div>

      {/* Auto DJ Info */}
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-bold text-[var(--text-primary)]">
          {autoDjCurrentTrack || autoDjText || 'מוזיקה אוטומטית'}
        </h2>
        {!autoDjCurrentTrack && (
          <p className="text-[var(--text-secondary)] text-sm">
            {autoDjSubtitle || 'הרדיו מנגן מוזיקה ברקע עד לשידור החי הבא'}
          </p>
        )}
      </div>
    </div>
  )
}
